module.exports = __webpack_public_path__ + "static/media/subscribe.18e77a7a.png";